module.exports = __webpack_public_path__ + "static/ugle-meeting-5e4b54515932aa653bd78043d562353c.jpg";